'use client';

import Link from 'next/link';

export default function GuestTrackForm() {
  return (
    <div className="guest-track">
      <h2 className="guest-track-title">Guest order tracking</h2>
      <p className="guest-track-copy">
        For guest checkouts, open the order status link from your Bathroomfort confirmation
        email. Account customers can sign in here to view recent orders.
      </p>
      <div className="guest-track-actions">
        <Link href="/account/login?next=/track-order" className="guest-track-primary">
          Sign in
        </Link>
        <Link href="/contact" className="guest-track-secondary">
          Contact support
        </Link>
      </div>

      <style>{`
        .guest-track {
          max-width: 480px;
          margin: 0 auto;
          background: var(--color-white);
          border: 1px solid var(--color-border);
          border-radius: 0.75rem;
          padding: 1.75rem;
          text-align: center;
        }
        .guest-track-title {
          font-size: 1.15rem;
          color: var(--color-text-primary);
          margin: 0 0 0.5rem;
        }
        .guest-track-copy {
          color: var(--color-text-secondary);
          font-size: 0.9rem;
          line-height: 1.55;
          margin: 0;
        }
        .guest-track-actions {
          display: flex;
          justify-content: center;
          gap: 0.75rem;
          flex-wrap: wrap;
          margin-top: 1.25rem;
        }
        .guest-track-primary,
        .guest-track-secondary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 2.6rem;
          padding: 0.7rem 1rem;
          border-radius: 1rem;
          font-size: 0.88rem;
          font-weight: 700;
          text-decoration: none;
        }
        .guest-track-primary {
          background: var(--color-primary);
          color: var(--color-white);
        }
        .guest-track-primary:hover { background: var(--color-primary-dark); }
        .guest-track-secondary {
          background: var(--color-white);
          color: var(--color-primary);
          border: 1px solid var(--color-border);
        }
        .guest-track-secondary:hover { border-color: var(--color-primary); }
      `}</style>
    </div>
  );
}
